module.exports = __webpack_public_path__ + "static/minnanobousai_logo_w600-dc9c2b5cd633de7580fc1f7fdc1f4b3b.png";